import axios from 'axios';

const initialState = {
  userSSOBoards: [],
  officeInfo: [],
  manualSearchError: false,
};

const mlsSSOErrorDefaultValue = {
  'board_id' : null,
  'agent_member_id' : 'Not Found',
  'office_id' : 'Not Found',
  'office_name' : 'Not Found',
  'manual_search' : false,
  'is_correct': false,
  'office_found': true,
};

const agentsErrorDefaultValue = {
  'Board' : null,
  'AgentId' : 'Not Found',
  'OfficeId' : 'Not Found',
  'OfficeName' : 'Not Found',
  'manual_search' : false,
  'is_correct': false,
  'office_found': true,
};

export default {
  namespaced: true,
  state: {
    ...initialState,
  },
  mutations: {
    setAvailableMlsBoards(state, boards) {
      state.userSSOBoards = boards.map(board => {
        if (board.board_id === 'crmls') {
          board.board_id = 'careg';
        }
        return board;
      });
    },
    setOfficeInfo(state, office) {
      if (office.board_id === 'crmls') {
        office.board_id = 'careg';
      }
      state.officeInfo.push(office);
    },
    setManualSearchStatus(state, boardId) {
      const index = state.officeInfo.findIndex(boardInfo => boardInfo.board_id === boardId);
      state.officeInfo[index].manual_search = !state.officeInfo[index].manual_search;
    },
    setManualSearchInfo(state, newInfo) {
      if (newInfo.Board === 'crmls') {
        newInfo.Board = 'careg';
      }
      const index = state.officeInfo.findIndex(boardInfo => boardInfo.board_id === newInfo.Board);
      state.officeInfo[index].agent_member_id = newInfo.AgentId;
      state.officeInfo[index].office_id = newInfo.OfficeId;
      state.officeInfo[index].office_name = newInfo.OfficeName;
      state.officeInfo[index].manual_search = false;
      state.officeInfo[index].is_correct = newInfo.is_correct;
      if (newInfo.OfficeName) state.officeInfo[index].office_found = true;
    },
    setManualSearchError(state, bool) {
      state.manualSearchError = bool;
    },
    removeOfficeInfo(state, boardId) {
      const index = state.officeInfo.findIndex(board => board.board_id === boardId);
      if(index !== -1) {
        state.officeInfo.splice(index, 1);
      }
    },
    removeAllOfficesInfo(state) {
      state.officeInfo = [];
    },
    setManualOfficeSearch(state, officeInfo) {
      if (officeInfo.Board === 'crmls') {
        officeInfo.Board = 'careg';
      }
      const index = state.officeInfo.findIndex(boardInfo => 
        boardInfo.board_id === officeInfo.Board && boardInfo.office_id === officeInfo.OfficeId);

      state.officeInfo[index].office_id = officeInfo.OfficeId;
      state.officeInfo[index].office_name = officeInfo.Name;
      state.officeInfo[index].office_found = true;
    },
    setBoardOfficeNameNotFound(state, boardId) {
      if (boardId === 'crmls') {
        boardId = 'careg';
      }
      const index = state.officeInfo.findIndex(boardInfo => boardInfo.board_id === boardId);

      state.officeInfo[index].office_found = false;
    },
  },
  getters: {
    getUserSSOBoards: state => {
      return state.userSSOBoards.map(board => board.board_id);
    },
    getOfficeInfo: state => {
      return state.officeInfo;
    },
    getOfficeDetails: state => boardId => {
      const { office_id, office_name } = state.officeInfo.find(office => office.board_id === boardId);
      return { office_id, office_name }
    },
    isManualSearchEnabled: state => boardId => {
      const board = state.officeInfo.find(office => office.board_id === boardId);
      return board ? board.manual_search : false;
    },
    isOfficeInfoValid: state => {
      if(!state.officeInfo.length) return true;
      return !state.officeInfo.some(board => board.is_correct == false);
    },
  },
  actions: {
    getAllOfficesInfo({ dispatch }, availableBoards) {
      availableBoards.forEach(board => {
        dispatch('fetchOfficeInfo', board);
      });
    },
    async fetchOfficeInfo({ dispatch }, boardId) {
      try {
        let response = await axios.get(`${process.env.VUE_APP_ACCOUNTS_API}/users/officeSSOInfo?board=${boardId}`);
        let [mlsSSOInfo] = response.data;
        mlsSSOInfo.manual_search = false;
        dispatch('getUserFeed', mlsSSOInfo);
      } catch (error) {
        if (boardId === 'careg') {
          dispatch('fetchOfficeInfo', 'crmls');
          return;
        }
        dispatch('setOfficeInfoError', boardId);
      }
    },
    async getUserFeed({ commit, dispatch }, officeInfo) {
      try {
        const response = await axios.get(`${process.env.VUE_APP_MLS_API_V2}/boards/${officeInfo.board_id}/agents/${officeInfo.agent_member_id}`);
        officeInfo.office_id = response.data.OfficeId;
        officeInfo.office_name = response.data.OfficeName;
        officeInfo.is_correct = true;
        commit('setOfficeInfo', officeInfo);

        const { OfficeId, OfficeName } = response.data;
        if (!OfficeName) {
          dispatch('manualOfficeSearch', { boardId: officeInfo.board_id, officeId: OfficeId });
        }
      } catch (error) {
        if (officeInfo.board_id === 'crmls') {
          officeInfo.board_id = 'careg';
          dispatch('getUserFeed', officeInfo);
          return;
        }
        officeInfo.is_correct = false;
        officeInfo.office_name =  'Not Found';
        commit('setOfficeInfo', officeInfo);
      }
    },
    async manualSearch({ commit, dispatch }, { boardId, agentId }) {
      try {
        const response = await axios.get(`${process.env.VUE_APP_MLS_API_V2}/boards/${boardId}/agents/${agentId}`);
        commit('setManualSearchInfo', response.data);

        const { OfficeId, OfficeName } = response.data;
        if (!OfficeName) {
          dispatch('manualOfficeSearch', { boardId, officeId: OfficeId });
        }

      } catch (error) {
        if (boardId === 'careg') {
          dispatch('manualSearch', { boardId: 'crmls', agentId });
          return;
        }
        dispatch('setManualSearchError', boardId);
      }
    },
    async manualOfficeSearch({ commit }, { boardId, officeId }) {
      try {
        const { data } = await axios.get(`${process.env.VUE_APP_MLS_API_V2}/boards/${boardId}/offices/${officeId}`);
        commit('setManualOfficeSearch', data.hits[0]);
      } catch(error) {
        commit('setBoardOfficeNameNotFound', boardId);
      }
    },
    disableManualSearch({ state, commit }) {
      state.officeInfo.forEach(board => {
        if(board.manual_search) {
          commit('setManualSearchStatus', board.board_id);
        }
      });
    },
    async getMlsBoards({ commit }) {
      try {
        const response = await axios.get(`${process.env.VUE_APP_ACCOUNTS_API}/users/officeSSOInfo`);
        commit('setAvailableMlsBoards', response.data);
      } catch (e) {
      }
    },
    setOfficeInfoError({ commit }, boardId) {
      commit('setOfficeInfo', {
        ...mlsSSOErrorDefaultValue,
        board_id: boardId,
      });
    },
    setManualSearchError({ commit }, boardId) {
      commit('setManualSearchError', true);
      commit('setManualSearchInfo', {
        ...agentsErrorDefaultValue,
        Board: boardId,
      });
    },
  },
};

